import React from 'react';
import ReactDOM from 'react-dom';
import { Tabs, Collapse, Badge, Button } from 'antd';
import { addCtnCommonAttribute, sgiCtnBaseFun } from "./SgiCtnComm"
import { convertModuleByGuid } from "./SgiCompComm"
import { uuid } from "rt-sd-common/sgiCommon/sgiCommon";
import { SgiEventHandler } from './SgiEventHandler';
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
// import { addTabCtlDndInfo } from '../sgiDndDev/sgiDndDevComFun'
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger'
import { AllCompGUID } from 'rt-sd-common/sgiConstants/SgiCompConstant';
import { StickyContainer, Sticky } from 'react-sticky';
import { getConstByKey, testReactVsn } from './sgiBaseComp/SgiCommon';
const TabPane = Tabs.TabPane;
// const Panel = Collapse.Panel;

const tabPanePrefix = "tp_";

const renderStickyTabBar = (props, DefaultTabBar) => (
	<Sticky bottomOffset={80}>
		{({ style }) => (
			<DefaultTabBar {...props} style={{ ...style, zIndex: 1 }} />
		)}
	</Sticky>
);

class SgiTabs extends React.Component {

	//这个暂时不好用 以后在处理
	static defaultProps = {
	};  // 注意这里有分号
	static propTypes = {
	};

	constructor(props) {
		super(props);
		this.state = {
			itemPanelType: "tabs",//区分是tab还是折叠面板的 普通面板整合tabpane和折叠panel
			tabsProps: { style: { height: "100%", width: "100%" } },//form属性
			tabsItems: [], //form下控件数组
			tabBarExtraContent: [],
			functions: {},
			activeKey: undefined,
			loading: false,
			cstmzTabsItems: undefined,//自定义获取选项卡项的方法

			// 异步加载
			isAsyn: false,//异步加载其余面板
			loadedKeys: [],//记录已加载项,异步加载查找未加载项使用
			allTabPaneAndSon: {},//根据key，记录所有tabpane和未加载的子module
		};
	}

    /**
     * 根据描述创建form
     * @param {父组件} parentModule
     * @param {描述} moduleDesc
     * @param {对象工厂} objFct
     * @param {make类型} type
     */
	tabs_mk(parentModule, moduleDesc, objFct, type) {
		//获取需要展示的数据信息
		if (!moduleDesc) {
			return;
		}

		this.state.tabsItems = []; //再次渲染的时候清空
		this.state.tabBarExtraContent = []; //再次渲染的时候清空
		//转换form公共属性
		addCtnCommonAttribute(this, moduleDesc, this.state.tabsProps);
		//转换基础属性
		this.AddAttribute(moduleDesc, this.state.tabsProps, this);

		//绑定事件
		this.bindEvent(moduleDesc, this.state.tabsProps, this.state.functions, type);
		//组装form表单下的控件信息
		if (type !== "dnd") this.fitTabsItems(moduleDesc, this.state.tabsItems, objFct, type);
		//组装tabBarExtraContent下的控件
		this.fitTabExtraContent(moduleDesc, this.state.tabBarExtraContent, objFct, type);
		//添加拖拽布局信息 根据type类型
		// addTabCtlDndInfo(this, this.state.tabsItems, this.state.tabsProps, type);
		let addTabCtlDndInfo = this.props.addTabCtlDndInfo;//显示/开发分离，这部分拖拽开发功能使用props传入
		if (addTabCtlDndInfo && typeof addTabCtlDndInfo === "function") {
			addTabCtlDndInfo(this, this.state.tabsItems, this.state.tabsProps, type);
		}
	}

    /**
     * 绑定事件
     * @param {*} moduleDesc
     * @param {*} tabsProps
     */
	bindEvent(moduleDesc, tabsProps, functions, type) {
		//拖拽模式 不生成事件
		var lsn = moduleDesc.tabLsn;// 选项卡监听器
		// var lsn = "tool.sgiLogger.log('11111111111111111',ComponentManager)"
		if (lsn && type != 'dnd') {
			try {
				var $tcl = new Function("module", "objFct", "activeKey", lsn);
				functions.tab = $tcl;
			} catch (e) {
				sgiLogger.eventErr(e);
			}
		}
		// tabsProps.onChange = SgiEventHandler.tcl.bind(this);
		tabsProps.onChange = (activeKey) => {
			if (this.state.isAsyn && this.state.loadedKeys.indexOf(activeKey) < 0) {
				let allTabPaneAndSon = this.state.allTabPaneAndSon || {};
				let activeTabInfo = allTabPaneAndSon[activeKey] || {};
				let activeTabPane = activeTabInfo.tabPane;
				let son = activeTabInfo.son;
				if (!activeTabPane || !son) {
					sgiLogger.error(`tabs 找不到key为${activeKey}的面板信息！`);
				} else {
					activeTabPane.props.children = son;
				}
			}
			SgiEventHandler.tcl.call(this, activeKey);
		};
	}


    /**
     * 根据描述组装子 操作按钮
     * @param {描述信息} moduleDesc
     * @param {属性} formProps
     */
	fitTabExtraContent = function (moduleDesc, tabsItems, objFct, type) {

		var me = this;

		// 拖拽模式特殊处理
		if (type === "dnd") {
			// 构建tabBarExtraContent
			const sonItems = me.props.children;
			if (sonItems && sonItems.length && sonItems.length > 0) {
				sonItems.forEach((child, index) => {
					const desId = child.props.moduleDesc.desId;
					// 处理工具条
					if (desId === AllCompGUID.TOOLBAR) {
						me.state.tabBarExtraContent.push(child);
					}
				});
			}
			return;
		}

		//form下的子节点添加到form组件中
		// me.itemPanelType = 'tabs';
		// tool.sgiLogger.log("tabs");
		let cldSet = moduleDesc.cldSet;
		if (cldSet && cldSet.length && cldSet.length > 0) {
			cldSet.forEach((item, index) => {
				// 处理工具条
				if (item.desId === AllCompGUID.TOOLBAR) {
					me.state.tabBarExtraContent.push(convertModuleByGuid(me, item, null, objFct, type));
				}
			});
		}
	}

    /**
    * 根据描述组装子对象
    * @param {描述信息} moduleDesc
    * @param {属性} formProps
    */
	fitTabsItems = function (moduleDesc, tabsItems, objFct, type) {
		var me = this;
		//form下的子节点添加到form组件中
		// me.itemPanelType = 'tabs';
		// tool.sgiLogger.log("tabs");

		let cldSet = moduleDesc.cldSet;
		if (cldSet && cldSet.length && cldSet.length > 0) {
			let tabPane;
			cldSet.forEach((item, index) => {

				// 跳过工具条构建
				if (item.desId === AllCompGUID.TOOLBAR) return;

				let { te, isDis } = item;
				let cId = getConstByKey(this, item.cId);
				tabPane = { forceRender: true }; //默认渲染
				if (!cId) {
					cId = uuid(8);
					item.cId = cId;
				}
				if (te) tabPane.tab = Resource.getTRByPrm(item).te;
				if (cId) tabPane.key = cId;
				if (isDis) tabPane.disabled = isDis;
				// if (cId) tabPane.ref = tabPanePrefix + cId;
				let tabPaneModule;
				let son = convertModuleByGuid(me, item, null, objFct, type, { setActiveWV: this.setActiveItem });
				let atvTab = getConstByKey(this, moduleDesc.atvTab);
				if (this.state.isAsyn && ((atvTab && atvTab !== cId) || (!atvTab && index !== 0))) {
					// tabsItems.push(<TabPane className="sgiTabPane" {...tabPane} />);
					tabPaneModule = <TabPane className="sgiTabPane" {...tabPane} />;
				} else {
					// tabsItems.push(<TabPane className="sgiTabPane" {...tabPane}>{convertModuleByGuid(me, item, null, objFct, type, { setActiveWV: this.setActiveItem })}</TabPane>);
					tabPaneModule = <TabPane className="sgiTabPane" {...tabPane}>{son}</TabPane>;
					this.state.loadedKeys.push(cId);
				}
				tabsItems.push(tabPaneModule);
				this.state.allTabPaneAndSon[cId] = { tabPane: tabPaneModule, son };
			});
		}
	}

    /**
     * 动态设置选项卡项(根据子组件描述)--外部接口
     * @param {Array} moduleDescs 子组件描述数组
     */
	setTabsItemsByDescs(moduleDescs, activeKey) {
		if (!moduleDescs) return;

		const { objFct } = this.props;
		let tabsItems = this.state.tabsItems = [];
		const me = this;

		this.state.cstmzTabsItems = function () {
			moduleDescs.forEach((desc, index) => {
				let tabPane = { forceRender: true }; //默认渲染;
				let { te, isDis } = desc;
				let cId = getConstByKey(this, desc.cId);
				if (!cId) {
					desc.cId = cId = uuid(8);
				}
				if (te) tabPane.tab = Resource.getTRByPrm(desc).te;
				if (cId) tabPane.key = cId;
				if (isDis) tabPane.disabled = isDis;
				if (index === 0) if (!activeKey) me.state.activeKey = cId;
				// if (cId) tabPane.ref = tabPanePrefix + cId;
				tabsItems.push(<TabPane className="sgiTabPane" {...tabPane}>{convertModuleByGuid(me, desc, null, objFct, null, { setActiveWV: me.setActiveItem })}</TabPane>);
			});
		}

		// 刷新
		this.setState({ activeKey });
	}
    /**
     * 动态设置选项卡项(根据TabPane属性)--外部接口
     * @param {array} propss 
     */
	setTabsItemsByTabPaneProps(propss, activeKey) {
		if (!propss) return;

		let tabsItems = this.state.tabsItems = [];
		const me = this;

		this.state.cstmzTabsItems = function () {
			propss.forEach((props, index) => {
				if (index === 0) if (!activeKey) me.state.activeKey = props.key;
				tabsItems.push(<TabPane className="sgiTabPane" {...props}></TabPane>);
			});
		}

		// 刷新
		this.setState({ activeKey });
	}
    /**
     * 动态设置选项卡项(传入创建好的子组件数组)--外部接口
     * @param {array} elements 
     */
	// setTabsItemsByElements(elements) {
	//     if (!elements) return;

	//     let tabsItems = this.state.tabsItems = [];
	//     tabsItems.push(...elements);

	//     // 刷新
	//     this.setState({});
	// }

	setActiveItem = (activeKey) => {
		if (this.state.activeKey === activeKey) {
			return;
		}
		this.state.activeKey = activeKey; //防止死循环，在tab中刷新wv，wv中再刷新 tab
		this.state.tabsProps.onChange(activeKey);
		this.setState({ loading: false });
	}
    /**
     * 获取当前激活面板的组件标识
     * @return {[type]} [description]
     */
	getActiveItem = () => {
		return this.state.activeKey;
	}

	refresh = () => {
		this.loaded = false;
		this.setState({ loading: false });
	}

    /**
     * 动态设置tab面板标题
     * @param {string} cId 对应面板组件标识
     * @param {string|Element} title 
     */
	setTabTitle(cId, title) {
		if (!cId || !title) return;
		this.state.tabsItems.some(item => {
			if (item.key === cId) {
				item.props.tab = title;
				if (testReactVsn(this, 16)) {
					// react16需要更新引用
					this.state.tabsItems = [...this.state.tabsItems];
				}
				this.setState({});
				return true;
			}
		});
	}

	//渲染并返回一个虚拟DOM
	render = function () {

		if (!this.loaded || this.props.type == 'dnd') {
			let { parentModule, moduleDesc, objFct, type } = this.props;
			//组装属性
			this.tabs_mk(parentModule, moduleDesc, objFct, type);
			this.loaded = true;
		}

		// 自定义选项卡项
		const { cstmzTabsItems } = this.state;
		if (cstmzTabsItems && typeof cstmzTabsItems === "function") {
			cstmzTabsItems();
			this.state.cstmzTabsItems = undefined;
		}

		// 通用渲染前处理，添加自定义样式等
		this.renderBeforeReturn(this.state.tabsProps);

		return (
			this.state.sticky ?
				<StickyContainer className="sgiStickyContainer-tabs">
					<Tabs className="sgiTabs" {...this.state.tabsProps}
						renderTabBar={renderStickyTabBar}
						tabBarExtraContent={this.state.tabBarExtraContent}
						activeKey={this.state.activeKey}>
						{this.state.tabsItems}
					</Tabs>
				</StickyContainer>
				:
				<Tabs className="sgiTabs" {...this.state.tabsProps}
					tabBarExtraContent={this.state.tabBarExtraContent}
					activeKey={this.state.activeKey}>
					{this.state.tabsItems}
				</Tabs>
		)
	}

    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formProps
     */
	AddAttribute = function (moduleDesc, tabsProps, tabs) {

		tabsProps.style.overflow = 'unset';

		//选项卡位置 left、top、right、bottom
		let tabPst = moduleDesc.tabPst; //tab面板位置
		if (tabPst) tabsProps.tabPosition = moduleDesc.tabPst;
		//选项卡按钮
		// 选项卡类型
		tabsProps.type = moduleDesc.type || "card"; //先默认这个 以后再去实现其他的属性
		// tabsProps.hideAdd =true;
		//初始化激活的面板
		let atvTab = getConstByKey(this, moduleDesc.atvTab);
		if (atvTab) {
			if (!tabs.state.activeKey) {
				tabs.state.activeKey = atvTab;
			}
			tabsProps.defaultActiveKey = atvTab;
		}

		// 切换动画
		tabsProps.animated = !!moduleDesc.animated;

		// 标题间隔
		const tbGutter = moduleDesc.tbGutter;
		tabsProps.tabBarGutter = (tbGutter || tbGutter === 0) ? parseInt(moduleDesc.tbGutter) : undefined;

		// 标题吸顶
		this.state.sticky = !!moduleDesc.sticky;

		// 是否异步加载其余页面
		this.state.isAsyn = moduleDesc.isAsyn;

	}
}
//给类添加公共方法
Object.assign(SgiTabs.prototype, sgiCtnBaseFun);

export { SgiTabs };
export default SgiTabs;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiTabs.js